import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [
      "common",
      "details",
      "home",
      "admin",
      "invoices",
      "profile",
      "footer",
      "registration",
      "tickets",
      "login",
      "signup",
      "security",
      "links",
      "accountinfo",
      "numberValidate",
      "errors",
      "contact-us",
      "download-center",
      "browse-apps",
      "forgot-password",
      "terms"
    ],
    fallbackLng: "en",
    // lng:'ar',
    supportedLngs: ["en", "ar"],
    initImmediate: false,
    interpolation: {
      escapeValue: true
    },
    debug: false,
    detection: {
      order: ["path", "cookie", "htmlTag"],
      caches: ["cookie"]
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    }
  });
